module.exports = __webpack_public_path__ + "static/media/kalendar_avacon.df968464.svg";